module.exports = __webpack_public_path__ + "img/no-preview-frame.1f1114f2.jpg";